/* eslint-disable react/jsx-no-useless-fragment */
import { RouteProps, Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../common/authentication/AuthLogin";

function PublicRoute({ children }: RouteProps): JSX.Element {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const isLoggedIn = auth.authenticated;

  const redirectToPrevious = () => {
    if (location.state?.from) {
      return <Navigate to={location.state.from} replace />;
    }
    return <Navigate to={"/dashboard"} replace />;
  };

  if (!isLoggedIn) {
    return <>{children}</>;
  }
  return redirectToPrevious();
}

export default PublicRoute;
